import gsap from "gsap"

export default class UserMenu {
    constructor() {
        this.menu = document.querySelector("#user-menu")
        this.menuButton = document.querySelector("#user-menu-btn")
        if (!this.menu) return
        this.setTimeline()
        this.events()
    }

    setTimeline() {
        this.timeline = gsap.timeline({
            paused: true
        })
        this.timeline.to(this.menu, {
            duration: 0.3,
            opacity: 1,
            y: 0,
            display: "flex",
            ease: "power2.inOut"
        })
    }

    toggle(e) {
        e.preventDefault()
        e.stopPropagation()
        this.menu.classList.toggle("open")
        if (this.menu.classList.contains("open")) {
            this.open()
        } else {
            this.close()    
        }
    }

    events() {
        // this.menu.addEventListener("click", () => this.toggle())
        // this.menu.addEventListener("mouseenter", () => this.toggle(true))
        // this.menu.addEventListener("mouseleave", () => this.toggle(false))

        this.menuButton.addEventListener("click", (e) => this.toggle(e))
    }

    open() {
        this.menu.classList.add("open")
        this.timeline.play()
    }

    close() {
        this.timeline.reverse()
    }
}